import React from 'react';
import { useScreenInit } from './useScreenInit';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { WhySeparovic } from './components/WhySeparovic';
import { FeesExplained } from './components/FeesExplained';
import { TeamSection } from './components/TeamSection';
import { ClaimRouter } from './components/ClaimRouter';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import type { ClaimType } from './types/claimCalculator';
interface ScreenState {
  calculatorStep?: number;
  calculatorClaimType?: ClaimType;
}
export function App() {
  const screenState = useScreenInit() as ScreenState;
  return <div className="min-h-screen w-full bg-canvas text-ink" data-id="element-0" data-mp="28s2xva27hvue">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-btn focus:bg-forest focus:px-4 focus:py-2 focus:text-paper" data-id="element-1" data-mp="23ujjma5idj2g">
        Skip to content
      </a>

      <AnnouncementBar data-id="element-2" data-mp="3rc9du70c5dx8" />
      <Header data-id="element-3" data-mp="3rbrcivytg9ig" />

      <main id="main-content" className="pb-[52px] xl:pb-0" data-id="element-4" data-mp="3rdar8i4tqci4">
        <Hero calculatorStep={screenState.calculatorStep} calculatorClaimType={screenState.calculatorClaimType} data-id="element-5" data-mp="5ygolyg4xb6" />
        <Testimonials data-id="element-6" data-mp="2zmeowbge3q93" />
        <WhySeparovic data-id="element-7" data-mp="2zmwh8wzxlkbq" />
        <FeesExplained data-id="element-8" data-mp="33mov9p83gioh" />
        <TeamSection data-id="element-9" data-mp="33m5eibu6k0c1" />
        <ClaimRouter data-id="element-10" data-mp="33ngdzzglelxc" />
        <FAQSection data-id="element-11" data-mp="33myl9ct52pu6" />
        <FinalCTA data-id="element-12" data-mp="33oi0d0326uud" />
      </main>

      <Footer data-id="element-13" data-mp="38li8dgjgy7o4" />
    </div>;
}